var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_239_33498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_239_33498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.1431,
    width: 6.85714,
    height: 16,
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H6.85714V0H0V16Z",
    fill: "#FF3131"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9186 7.27601C13.6801 7.49861 13.2968 7.28148 13.3652 6.96248L13.7143 5.33333L12.5714 5.86666L12 4.26666L11.4286 5.86666L10.2857 5.33333L10.6348 6.96248C10.7032 7.28148 10.3199 7.49861 10.0814 7.27601L9.94173 7.14561C9.81366 7.02607 9.61492 7.02607 9.48685 7.14561L9.14286 7.46666L8 6.93333L8.57143 8L8.26109 8.28964C8.1199 8.42142 8.1199 8.64524 8.26109 8.77701L9.71429 10.1333H11.4286L11.7143 11.7333H12.2857L12.5714 10.1333H14.2857L15.7389 8.77701C15.8801 8.64524 15.8801 8.42142 15.7389 8.28964L15.4286 8L16 6.93333L14.8571 7.46666L14.5132 7.14561C14.3851 7.02607 14.1863 7.02607 14.0583 7.14561L13.9186 7.27601Z",
    fill: "#FF3131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.ef5183c80df51e7ec0b16671c63c8033.svg";
export { ForwardRef as ReactComponent };